import React from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'

import Axios from '@components/Axios'
import Card from '@components/Card'
import Button from '@components/Button'

import FormGroup from './components/FormGroup'

const AddEditPrivacy = props => {
  let { item, updateList } = props

  const schema = {
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object().shape({
      text: Yup.string().required('REQUIRED'),
      title: Yup.string().required('REQUIRED')
    })
  }

  const onSubmit = ({ values, submit, resetForm }) => {
    submit({ params: values })
    resetForm()
  }

  const footer = submit => {
    return <Button onClick={submit}>PRIVACY_ADD_CARD_SEND</Button>
  }

  const add = ({ handleSubmit, ...formik }) => {
    return (
      <Card footer={() => footer(handleSubmit)}>
        <FormGroup {...props} formik={formik} />
      </Card>
    )
  }

  return (
    <div className="AddEditPrivacy">
      <Axios method="put" api="admin.privacypage" onSuccess={updateList}>
        {({ submit }) => (
          <Formik
            {...schema}
            onSubmit={(values, event) => onSubmit({ ...event, values, submit })}
          >
            {formik => add(formik)}
          </Formik>
        )}
      </Axios>
    </div>
  )
}

export default AddEditPrivacy
